import { NavLink } from 'react-router-dom';
import './Footer.css';
import CTA from '../../components/CTA/CTA';
import { Fade } from 'react-reveal';

const Footer = () => {
  return (
    <div className='footer'>
      <CTA />
      <div className='footer-container'>
        <div className='footer-logo'>
          <img src='/assets/footer-logo.svg' alt='logo' />
        </div>
        <div className='footer-email-flex'>
          <div className='footer-email'>
            <a href="mailto:support@qevolt.com">support@qevolt.com</a>
            <div className='only-mobile'>
              <p>© Qevolt Limited</p>
            </div>
          </div>
          <div className='footer-socials'>
            <a
              href='https://twitter.com/qevolt?s=20&t=OH-9Axykzv2OY7umpIMZNQ'
              target='_blank'
              className='footer-twitter'
            >
              <img src='./assets/twitter.svg' alt='twitter' />
            </a>
            <a
              href='https://www.instagram.com/qevolthq/'
              target='_blank'
              className='footer-instagram'
            >
              <img src='./assets/instagram.svg' alt='instagram' />
            </a>
          </div>
        </div>
        <div className='footer-service'>
          <p className='non-mobile'>Banking Services by Kuda MFB </p>
        </div>
        <div className='footer-links'>
          <div className='left-footer-links'>
            <p className='non-mobile'>© Qevolt Limited</p>
          </div>
          <div className='right-footer-links non-mobile'>
            {/* <NavLink to="/about">About us</NavLink> */}
            <NavLink to='/policy'>Privacy Policy</NavLink>
            <NavLink to='/'>Cookie Policy</NavLink>
            <NavLink to='/terms'>Terms of use</NavLink>
            
          </div>

          <div className='footer-mobile-links only-mobile'>
            <NavLink to='/faqs'>Faqs</NavLink>
            <NavLink to='/policy'>Privacy Policy</NavLink>
            <NavLink to='/'>Cookie Policy</NavLink>
            <NavLink to='/terms'>Terms of use</NavLink>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
